import objectPath from 'object-path'
import { getDataValue } from '../element/table/Render'
import { checkHasShow, checkIsShow } from './condition/Action'
import { getExternalRequest, getServiceRequest, setApi } from './Api'
import { createInputOption, createTabFormOptions } from './Option'

const pendingOptionRequests = {}

const parseArrayOptions = (textarea = '') => {
  try {
    return JSON.parse(textarea) || []
  } catch (error) {
    return []
  }
}

const getFetchOptionFormData = (formData = {}, isFetchOption = {}) => {
  let optionFormData = { ...(formData || {}) }
  if (!objectPath.has(isFetchOption, 'valueChange')) return optionFormData

  let ruleUiKeys = Array.isArray(isFetchOption.ruleUiKeys)
    ? isFetchOption.ruleUiKeys
    : []

  ruleUiKeys
    .filter((key) => key)
    .forEach((key) => {
      objectPath.set(optionFormData, key, isFetchOption.valueChange)
    })

  return optionFormData
}

export const createDropdownApiData = (designContext = {}, formData = {}) => {
  let datasourceValue =
    objectPath.get(designContext, '@datasource') ||
    designContext.datasourceValue ||
    designContext.datasource ||
    {}
  let urlParams = designContext.urlParams || {}
  let allParams = { ...urlParams, ...(designContext.allParams || {}) }

  return {
    formData,
    allParams,
    urlParams,
    designerData: designContext.designerData || {},
    datasourceValue,
    tabParamActive: designContext.tabParamActive || {},
    keyword: designContext.keyword || {},
    searchData: designContext.searchData || {},
    user: designContext.user || {},
  }
}

export const createOptions = ({
  uischema,
  config,
  designContext,
  listOption,
  isFetchOption,
  formComponentName,
}) => {
  const { selectApiOption, widgetName, isUiChanged, setIsUiChanged } =
    designContext
  let { optionType = {}, isAll, allLabel, allValue, joinTitle = '' } = uischema

  const { isDynamic = false, dynamicIndex = 0, formComponent } = config
  const uiSelectKey = uischema.key
  const list = objectPath.get(uischema, `${optionType}`) || {}
  const isCustomSelect = ['custom', 'array'].includes(optionType)
  const optionApiName = widgetName ? `${widgetName}.${list?.url}` : list?.url
  const hasSelectApi = objectPath.has(selectApiOption, optionApiName)
  const { optionValue = 'value' } = list
  const uiTitleValue = uischema?.titleValue
  const listTitleValue = list?.titleValue
  const titleValue =
    Array.isArray(uiTitleValue) && uiTitleValue.length > 0
      ? uiTitleValue
      : Array.isArray(listTitleValue) && listTitleValue.length > 0
      ? listTitleValue
      : []
  const hasTitleValue = titleValue.length > 0

  let options = isAll
    ? [
        {
          label: allLabel,
          [optionValue]: allValue,
          isAll: true,
        },
      ]
    : []

  if (isDynamic && isFetchOption) {
    if (isFetchOption.dynamicIndex !== dynamicIndex) {
      listOption =
        objectPath.get(isUiChanged, [
          'tempDynamicOption',
          uiSelectKey,
          isFetchOption.dynamicIndex,
        ]) || []
    }
  }
  if (!listOption) {
    if (isCustomSelect) {
      listOption = list?.options
    } else if (hasSelectApi) {
      listOption = objectPath.get(selectApiOption, optionApiName)
    } else {
      listOption = []
    }
  }

  if (Array.isArray(listOption)) {
    options = options.concat(listOption)
  } else if (listOption && typeof listOption === 'object') {
    let keyList = Object.keys(listOption)
    let newList = []
    keyList.forEach((key) => {
      let item = {
        label: key,
        [optionValue]: objectPath.get(listOption, key),
      }
      newList.push(item)
    })
    options = options.concat(newList)
  }
  if (hasTitleValue) {
    let keyOptions = list.keyOptions
    options.map((option) => {
      let titleList = []
      let labelList = []
      let fontColor = ''
      let fontWeight = ''
      let isLockedSelect
      let hasAttachId = false
      titleValue.forEach(
        ({
          valueType = 'string',
          title,
          replaceValues,
          fontWeight: titleFontWeight,
        }) => {
          let itemFontColor = ''
          let itemFontWeight = titleFontWeight || ''
          if (valueType === 'attachmentId') {
            hasAttachId = true
          } else {
            let subTitle = []
            title.forEach((title) => {
              let labelValue = title.value
              let isLabelName = keyOptions.includes(labelValue)
              let hasValue = objectPath.has(option, title.value)
              if (hasValue) {
                labelValue = objectPath.get(option, title.value)
                if (replaceValues) {
                  let foundReplace = replaceValues.find(({ value }) => {
                    let aValue = getDataValue(labelValue)
                    let bValue = getDataValue(value)
                    return aValue === bValue
                  })
                  if (foundReplace) {
                    let { replace } = foundReplace
                    labelValue = replace
                    itemFontColor = foundReplace.fontColor
                    itemFontWeight = foundReplace.fontWeight || titleFontWeight
                    isLockedSelect = foundReplace.isLockedSelect
                  }
                }
              } else {
                if (isLabelName) {
                  labelValue = ''
                }
              }
              subTitle.push(labelValue)
            })
            let label = subTitle.join('')
            fontColor = itemFontColor || fontColor
            fontWeight = itemFontWeight || fontWeight
            titleList.push(label)
            labelList.push({
              label,
              fontColor: itemFontColor,
              fontWeight: itemFontWeight,
            })
          }
        },
      )
      if (hasAttachId) {
        objectPath.set(option, '@isAttachValue', true)
        return option
      }

      let labelValue = titleList.join(joinTitle)
      objectPath.set(option, '@isUseTitleValue', true)
      objectPath.set(option, '@label', labelValue)
      objectPath.set(option, '@labelList', labelList)
      objectPath.set(option, '@fontColor', fontColor)
      objectPath.set(option, '@fontWeight', fontWeight)

      if (isLockedSelect) {
        objectPath.set(option, 'isDisabled', fontColor)
      }
      return option
    })
  }
  if (isDynamic && isFetchOption) {
    if (isFetchOption.dynamicIndex === dynamicIndex) {
      objectPath.set(
        isUiChanged,
        ['tempDynamicOption', uiSelectKey, isFetchOption.dynamicIndex],
        options,
      )
    }
  }
  setIsUiChanged(isUiChanged)
  return options
}

export const getOptionData = async ({
  uischema,
  config = {},
  designContext,
  key,
  propSelect = {},
  data,
  formComponentName,
  setOptions,
}) => {
  let { isFetchOption, isCallOption = false, forceFetch } = propSelect
  const { jsonForm, isUiChanged, setIsUiChanged } = designContext
  let { optionType = {} } = uischema
  const { isDynamic = false, dynamicIndex = 0 } = config
  const uiSelectKey = uischema.key
  const widgetName = config?.widgetName
  const isForceFetchOption = Boolean(forceFetch || isFetchOption?.forceFetch)

  if (!key) return
  if (key !== uiSelectKey) return
  let hasShow = checkHasShow({ designContext, uischema: { key } })
  let isShow = checkIsShow({ designContext, uischema: { key } })
  if (hasShow && !isShow) {
    return
  }
  let optionData = objectPath.get(uischema, `${optionType}`) || {}
  let { service, endpoint, pathParams, queryParams, url, page, perPage } =
    optionData
  let options
  if (optionType === 'array') {
    let { textarea = '' } = optionData
    options = parseArrayOptions(textarea)
  } else if (optionType === 'custom') {
    options = optionData.options || []
  } else {
    let action = {
      apiType: optionType,
      service,
      endpoint,
      pathParams,
      queryParams,
      isOption: true,
      jsonForm,
      page,
      perPage,
    }
    if (isFetchOption) {
      let { isDynamic, dynamicName, dynamicIndex } = isFetchOption
      let dynamicData = objectPath.get(
        jsonForm.formData,
        `${dynamicName}.${dynamicIndex}`,
      )
      action = {
        ...action,
        isDynamic,
        dynamicData,
        isOption: true,
      }
    }
    let formData = isFetchOption
      ? getFetchOptionFormData(
          { ...(data || {}), ...(jsonForm.formData || {}) },
          isFetchOption,
        )
      : data
    let apiData = createDropdownApiData(designContext, formData)
    let api = setApi(action, formData, apiData)
    let optionTempPath = ['optionsTemp', jsonForm.formCode, api]
    let requestKey = `${jsonForm.formCode || ''}:${api}`
    if (!isForceFetchOption && objectPath.has(isUiChanged, optionTempPath)) {
      options = objectPath.get(isUiChanged, optionTempPath)
    } else {
      if (!pendingOptionRequests[requestKey]) {
        pendingOptionRequests[requestKey] = (async () => {
          if (optionType === 'internal') {
            if (api?.startsWith('?')) {
              return
            }
            if (!service || !endpoint) {
              return
            }
            optionData = await getServiceRequest(
              api,
              optionData,
              uischema,
              formData,
            )
          } else if (optionType === 'external') {
            if (!url) {
              return
            }
            optionData = await getExternalRequest(api, optionData, uischema)
          } else if (optionType === 'array') {
            let { textarea = '' } = optionData
            optionData = parseArrayOptions(textarea)
          }
          let options = optionData.options || []
          options = createOptions({
            uischema,
            config,
            designContext,
            listOption: options,
            isFetchOption,
            formComponentName,
          })
          objectPath.set(isUiChanged, optionTempPath, options)
          setIsUiChanged(isUiChanged)
          return options
        })()
      }
      try {
        options = await pendingOptionRequests[requestKey]
      } finally {
        delete pendingOptionRequests[requestKey]
      }
    }
  }
  if (setOptions) {
    setOptions(options)
  }
  return options
}

export const createDropdown = async (designContext) => {
  let { jsonForm } = designContext
  let specificTag = 'select'
  let inputOption = createInputOption(jsonForm, specificTag, null, {
    isReturnUi: true,
  })
  let data = jsonForm.formData
  let propSelect = { isFetchOption: false, isCallOption: true }
  let promiseList = inputOption.map((uischema) => {
    let key = uischema.key
    return getOptionData({
      uischema,
      designContext,
      key,
      data,
      propSelect,
    }).catch((error) => console.error('There was an error!', error))
  })
  await Promise.all(promiseList)
}
